import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      margin: 0,
      "& div": {
        height: "80px",
        width: "350px",
      },
    },
    textField: {
      minWidth: "150px",
      width: "100%",
      "& input": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        direction: "rtl",
        textAlign: "left",
        "&:focus": {
          direction: "ltr",
        },
      },
      "& > .MuiInputLabel-root": {
        color: "rgba(0, 0, 0, 0.6)",
      },
    },
    endAdornment: {
      display: "flex",
      width: "30px! important",
      justifyContent: "flex-end",
    },
    clearIndicator: {
      position: "absolute",
      right: "30px",
    },
    validField: {
      "& > .MuiInputLabel-root": {
        color: theme.additionalColors.ampelGruen,
      },
      "& fieldset": {
        borderColor: `${theme.additionalColors.ampelGruen}!important`,
      },
    },
  })
);

export default useStyles;
